import { FullscreenImageLayout, Stack } from 'ui-components';
import { BasicStoreFragment, useGetStoresQuery } from 'drycut-graphql';
import SalonCard from './SalonCard';
import background from '../../../assets/salons.jpg';

type Props = {
  includeWaitingTime?: boolean;
};

export function SalonList({ includeWaitingTime = false }: Props): React.ReactElement {
  const { data } = useGetStoresQuery();

  const stores = data?.stores?.nodes || [];
  const validStores = stores.filter((node): node is BasicStoreFragment => Boolean(node));

  return (
    <FullscreenImageLayout src={background}>
      <Stack className="h-screen justify-center p-10 items-center">
        <div className="grid grid-cols-2 gap-x-10 gap-y-10 container">
          {validStores.map((store) => (
            <SalonCard key={store.id} salon={store} includeWaitingTime={includeWaitingTime} />
          ))}
        </div>
      </Stack>
    </FullscreenImageLayout>
  );
}
